/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * The param component for wizard notification
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.2.0
 */

import { Fragment, ReactNode, useState } from 'react';

import { LayoutStyled } from '../../../../components/common/Block/Layout';
import CheckboxServiceUserDenied from '../../../role/components/CheckboxServiceUserDenied';
import { WizardReportParamLabelStyled } from './styled/WizardReportStyled';

export interface IWizardReportParamProps {
    children?: ReactNode;
    dataName?: string;
    disabled?: boolean;
    isEnabled: boolean;
    label: string;
    setEnabled: (value: boolean) => void;
}

export const WizardReportParam = (props: IWizardReportParamProps) => {
    const [isMouseOver, setMouseOver] = useState(false);

    return (
        <Fragment>
            <WizardReportParamLabelStyled
                data-name={props.dataName || ''}
                onMouseLeave={() => setMouseOver(false)}
                onMouseOver={() => setMouseOver(true)}
            >
                <CheckboxServiceUserDenied
                    checked={props.isEnabled}
                    className={isMouseOver ? 'hover' : ''}
                    disabled={props.disabled}
                    onChange={() => props.setEnabled(!props.isEnabled)}
                >
                    { props.label }
                </CheckboxServiceUserDenied>
            </WizardReportParamLabelStyled>
            {
                props.isEnabled && !!props.children &&
                <LayoutStyled className="mb-3">
                    {props.children}
                </LayoutStyled>
            }
        </Fragment>
    )
};
